import baseAPI from '@/http'

const router = 'api/Medalha'
const routerTemas = 'api/Tema'

export const medalhaAPI = {
  create: (data) => baseAPI.post(router + '/cadastrar-medalha', data),
  update: (data) => baseAPI.put(router + '/atualizar-medalha', data),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  get: (id) => baseAPI.get(`${router}/${id}`),
  list: () => baseAPI.get(router),
  getTemas: () => baseAPI.get(routerTemas)

}
